import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-explore-two',
  templateUrl: './explore-two.component.html',
  styleUrls: ['./explore-two.component.scss']
})
export class ExploreTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
